export const QA_NAME_LIST_ITEM_CONTEXT = 'item'
